//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SEO from '~/mixins/SEO.js'
import JSONSCHEMA from '~/mixins/JSONSCHEMA.js';
import DentBanner from '../../components/Banners/DentBanners/DentBanner.vue';
import HairBanner from '../../components/Banners/HairBanners/HairBanner.vue';
import ObesityBanner from '../../components/Banners/ObesityBanners/ObesityBanner.vue';
import AlignedSmileBanner from '../../components/Banners/DentBanners/AlignedSmileBanner.vue';
import GeneralBanner from '../../components/Banners/GeneralBanners/GeneralBanner.vue';

export default {
  layout: 'blog',
  name: 'index',
  mixins: [SEO, JSONSCHEMA],
  data() {
    return {
      latestpost: {},
      currentPage: 1,
    }
  },
  components: {
    DentBanner,
    HairBanner,
    ObesityBanner,
    AlignedSmileBanner,
    GeneralBanner

  },

  methods: {
    async fetchLatestPost(index) {
      if (this.$route.query.page != index) {
        this.$router.push({ path: this.$route.path, query: { page: `${index}` } })
        const latestpostResponse = await this.$api.latestPosts(index)
        this.latestpost = latestpostResponse.content
        var element = document.getElementsByClassName('rightside-sidebar')[0];
        window.scrollTo(0, element.offsetTop);
        this.currentPage = index
      }
    },
  },
  mounted() {
    if (this.$route && this.$route.query && this.$route.query.page) {
      this.currentPage = Number(this.$route.query.page)
    } else {
      this.currentPage = 1
    }
    this.$router.push({ path: this.$route.path, query: { page: `${this.currentPage}` } })
  },
  // async fetch() {
  //     const responsePage = await this.$api.fetchBlog()
  //     this.page = responsePage.content
  //     const latestpostResponse = await this.$api.latestPosts(1)
  //     this.latestpost = latestpostResponse.content
  // },
  async asyncData({ $api, query }) {
    const responsePage = await $api.fetchBlog()
    const page = responsePage.content
    const latestpostResponse = await $api.latestPosts(query.page ? query.page : 1)
    const latestpost = latestpostResponse.content
    return { page, latestpost }
  },
  computed: {
    getRandomBanner() {
      return Math.floor(Math.random() * 3); // Returns 0, 1, or 2 randomly
    }
  }
}
